import template from './sales-by-subfamily.html';
import controller from './sales-by-subfamily.controller';
import './sales-by-subfamily.scss';

let SalesBySubfamilyComponent = {
  //Zilch
  bindings: {
  },
  template,
  controller
};

export default SalesBySubfamilyComponent;



// WEBPACK FOOTER //
// ./src/app/pages/sales-by-subfamily/sales-by-subfamily.component.js